import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { EntityConditionGroup, EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { AuthDetailsService } from '../../../common/auth-details/auth-details.service';

@Injectable({
	providedIn: 'root'
})
export class SuperAdminService extends iBisSecureEditService {

	public data: CustomStore;
	public doctorsStore: CustomStore;
	public doctors: any[] = [];
	/** DataSource pacienți cu paginare (pageSize 20), ca în edit-patient. */
	public patientsDataSource: DataSource;

	/** Filtru: data selectată (implicit azi) */
	public selectedDate: Date;
	/** Filtru: doctor selectat (userId) */
	public selectedUserId: string | null = null;

	constructor(
		auth: iBisAuthService,
		entity: iBisEntityService,
		config: iBisServerConfig,
		lg: iBisLanguageService,
		private ad: AuthDetailsService
	) {
		super(auth, entity, config, lg);
		this.title = 'SUPER_ADMIN';
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		this.selectedDate = today;
		this.ad.onDataChanged.subscribe(_ => this.load());
	}

	/** Apelat la deschiderea paginii ca să se încarce doctorii și datele. */
	public ensureLoaded(): void {
		this.load();
	}

	protected load(): void {
		const qq = new EntityQuery('Patient').addOrderBy(['lastName']);
		const store = this.entity.store(qq, false, 'id');
		this.patientsDataSource = new DataSource({
			store: store,
			paginate: true,
			pageSize: 20
		});
		const applyFilters = () => {
			this.loadDoctors();
			this.data = this.getData();
		};
		this.ad.partyUserDataLoadedSubject.subscribe(_ => applyFilters());
		if (this.ad.authDetails?.party?.id) {
			applyFilters();
		}
	}

	/** Reîncarcă store-ul de programări cu filtrele curente (dată, doctor). */
	public refreshData(): void {
		this.data = this.getData();
	}

	public loadDoctors(): void {
		const doctorRoleIdQ = new EntityQuery('UserLoginRole').eq('name', 'doctor')
			.link('groupId', 'id', new EntityQuery('EnumValue').linkEq('typeId', 'id', 'EnumType', 'name', 'ROLE_GROUP'));
		this.entity.single(doctorRoleIdQ, this.config.saasServer).then((doctorRole: any) => {
			const q = new EntityQuery('PartyUser')
				.eq('roleId', doctorRole.id)
				.eq('partyId', this.ad.authDetails.party.id);
			this.entity.load(q).then((clinicDoctors: any[]) => {
				if (!clinicDoctors || clinicDoctors.length === 0) {
					this.doctors = [];
					return;
				}
				const userQ = new EntityQuery('UserLogin').eq('isActiv', true)
					.in('id', clinicDoctors.map(cd => cd.userId));
				this.entity.load(userQ, this.config.saasServer).then((users: any[]) => {
					this.doctors = users || [];
				});
			});
		});
	}

	private getData(): CustomStore {
		const startOfDay = new Date(this.selectedDate);
		startOfDay.setHours(0, 0, 0, 0);
		const endOfDay = new Date(this.selectedDate);
		endOfDay.setHours(23, 59, 59, 999);

		let q = new EntityQuery('Appointment')
			.eq('partyId', this.ad.authDetails.party.id)
			.eq('statusId', 5)
			.gte('startDate', startOfDay)
			.lte('startDate', endOfDay)
			.addOrderBy(['startDate']);

		if (this.selectedUserId) {
			q = q.eq('userId', this.selectedUserId);
		}

		return this.entity.store(q, false, 'id');
	}

	createDefault(): any {
		return {};
	}

	getById(id: string): Promise<any> {
		return this.entity.getById('Appointment', id);
	}

	onRemove(id: string): Promise<void> {
		return this.entity.remove('Appointment', id);
	}

	onSaveEv(): Promise<any> {
		return this.entity.save('Appointment', this.model?.id, this.model);
	}

	reset(): void {
		this.model = this.createDefault();
	}
}
